module.exports = __webpack_public_path__ + "53dd29b4e206ca28466424ac917a0027.svg";